import { Outlet } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import Sidebar from "./Sidebar/Sidebar";
import MobileAppHeader from "./MobileAppHeader/MobileAppHeader";
import MobileBottomNav from "./MobileBottomNav/MobileBottomNav";
import { useMainStore } from "@/stores/index";
import TrialExpiredModal from "@/shared/components/ui/Modal/TrialExpiredModal";
import EnrichmentEnterpriseModal from "@/shared/components/ui/Modal/EnrichmentEnterpriseModal";
import WhatsNew from "@/shared/components/WhatsNew/WhatsNew";
import { useEnrichmentModalStore } from "@/stores/useEnrichmentModalStore";
import { isTrialExpired } from "@/shared/utils/trialUtils";
const MainAppLayout = () => {
  const { sidebarExpanded, setSidebarExpanded, user } = useMainStore();
  const {
    isOpen: enrichmentModalOpen,
    message: enrichmentModalMessage,
    closeModal: closeEnrichmentModal,
  } = useEnrichmentModalStore();
  const trialExpired = useMemo(() => isTrialExpired(user), [user]);
  const [serverReportedTrialExpired, setServerReportedTrialExpired] =
    useState(false);

  useEffect(() => {
    if (!trialExpired) setServerReportedTrialExpired(false);
  }, [trialExpired]);

  useEffect(() => {
    console.info("[DEBUG-MAIN-APP-LAYOUT] layout ready", {
      sidebarExpanded,
      viewport: typeof window !== "undefined"
        ? `${window.innerWidth}x${window.innerHeight}`
        : "server",
    });
  }, [sidebarExpanded]);

  useEffect(() => {
    const handleTrialExpired = () => {
      setServerReportedTrialExpired(true);
    };
    window.addEventListener("trialExpired", handleTrialExpired);
    return () => {
      window.removeEventListener("trialExpired", handleTrialExpired);
    };
  }, []);

  return (
    <div className="flex h-[100dvh] w-full flex-col bg-white dark:bg-gray-950 text-gray-900 dark:text-gray-100">
      <MobileAppHeader />
      <div className="flex min-h-0 flex-1 overflow-hidden">
        <aside
          className={`hidden md:sticky md:top-0 md:block md:h-[100dvh] md:self-start ${sidebarExpanded ? "w-[216px]" : "w-[68px]"
            } shrink-0 transition-all duration-300`}
        >
          <Sidebar expanded={sidebarExpanded} setExpanded={setSidebarExpanded} />
        </aside>
        <main className="app-canvas min-h-0 min-w-0 flex-1 overflow-y-auto dark:bg-gray-950 pt-4 pb-[calc(3.5rem+env(safe-area-inset-bottom))] md:pb-0 transition-all duration-300">
          <Outlet />
        </main>
      </div>
      <MobileBottomNav />
      <TrialExpiredModal isOpen={trialExpired || serverReportedTrialExpired} />
      <EnrichmentEnterpriseModal
        isOpen={enrichmentModalOpen}
        onClose={closeEnrichmentModal}
        message={enrichmentModalMessage}
      />
      <WhatsNew />
    </div>
  );
};

export default MainAppLayout;
